import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import {
  MeetingFilterOptions,
  PagedMeeting,
  Meeting,
} from 'lib/Model/Meetings';

export function fetchMeetingFilterOptions(): Promise<MeetingFilterOptions> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/meetings/filters`, {
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return response.data as MeetingFilterOptions;
    });
}

export function fetchAllMeetings(
  pageNumber: number,
  itemsPerPage: number,
  dateFrom?: string,
  dateTo?: string,
  searchParam?: string,
  unitName?: string,
  individualName?: string,
  hasCompany?: string,
): Promise<PagedMeeting> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/meetings`, {
      params: {
        page: pageNumber,
        page_size: itemsPerPage,
        date_from: dateFrom,
        date_to: dateTo,
        search_param: searchParam,
        unit_name: unitName,
        individual_name: individualName,
        has_company: hasCompany,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return {
        total_count: response.data.total_count,
        data: response.data.data as Meeting[],
      };
    });
}

export function exportMeetings(
  dateFrom?: string,
  dateTo?: string,
  searchParam?: string,
  unitName?: string,
  individualName?: string,
  hasCompany?: string,
): Promise<void> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/meetings/export`, {
      params: {
        date_from: dateFrom,
        date_to: dateTo,
        search_param: searchParam,
        unit_name: unitName,
        individual_name: individualName,
        has_company: hasCompany,
      },
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      const now = new Date();
      const date = now.toISOString().split('T')[0];
      const time = now.toTimeString().split(' ')[0].replace(/:/g, '');
      const filename = `meetings_export_${date}${time}.xlsx`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
}
